// Icon registry — user can pick from these in admin Settings
import {
  Gift, PartyPopper, Sparkles, Star, Award, Trophy, Crown,
  Wallet, Banknote, BadgeIndianRupee, CreditCard, Coins, IndianRupee, PiggyBank,
} from 'lucide-react';

export const BONUS_ICONS = {
  Gift, PartyPopper, Sparkles, Star, Award, Trophy, Crown,
};

export const WITHDRAW_ICONS = {
  Wallet, Banknote, BadgeIndianRupee, CreditCard, Coins, IndianRupee, PiggyBank,
};

export const getBonusIcon = (name) => BONUS_ICONS[name] || PartyPopper;
export const getWithdrawIcon = (name) => WITHDRAW_ICONS[name] || Wallet;
